export const DELETE_PERSON_EMERGENCY_CONTACT = "deletePersonEmergencyContact";
export const FETCH_PERSON_EMERGENCY_CONTACT_LIST = "fetchPersonEmergencyContactList";
export const SAVE_EDITED_PERSON_EMERGENCY_CONTACT = "saveEditedPersonEmergencyContact";
export const SAVE_NEW_PERSON_EMERGENCY_CONTACT = "saveNewPersonEmergencyContact";
